import { ReactNode } from 'react';
import { Control, FieldPathByValue, FieldValues } from 'react-hook-form';

import { Timezone } from '@willow/graphql-iso/src/app';
import { formatTimezone } from '@willow/shared-iso';

import { ControlledSelect } from './ControlledSelect';

// Values are the GraphQL Timezone enum (what consumers store); labels come from `formatTimezone`,
// so the PT/MT/CT/ET strings live in exactly one place.
const TIMEZONE_OPTIONS = [
  Timezone.AmericaLosAngeles,
  Timezone.AmericaDenver,
  Timezone.AmericaChicago,
  Timezone.AmericaNewYork,
].map((value) => ({ value, label: formatTimezone(value) }));

type Props<T extends FieldValues> = {
  fieldName: FieldPathByValue<T, boolean | string | number | undefined | null>;
  control: Control<T>;
  hideErrorMessage?: boolean;
  label?: ReactNode;
  hint?: ReactNode;
  placeholder?: string;
  required?: boolean;
};

export function ControlledTimezoneSelect<T extends FieldValues>(props: Props<T>) {
  return <ControlledSelect options={TIMEZONE_OPTIONS} {...props} isClearable={false} />;
}
